__turbopack_context__.v({
  "block": "contactDetailsBox-module__6Ckp-q__block",
  "header": "contactDetailsBox-module__6Ckp-q__header",
  "subHeader": "contactDetailsBox-module__6Ckp-q__subHeader",
  "textContainer": "contactDetailsBox-module__6Ckp-q__textContainer",
});
